module.exports = __webpack_public_path__ + "static/img/img-features-feature-2-game-7@2x.810d15c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-2-game-7@2x.png
// module id = ADv5
// module chunks = 18